// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__TvmN2","row":"Node_row__6XFJG","label":"Node_label__1Z85N","footer":"Node_footer__3aIAB"};